import './PollingRefresh.scss';

import PollingRefresh from './PollingRefresh';

export default PollingRefresh;
